import type { Value, PointTarget, EdgeTarget, GeometryElementDisplayConfig } from '../../../geometrypad.model';

// =============================================================================
// TYPES
// =============================================================================

export interface SquareElement {
  type: 'Square';
  params?: {
    s?: Value;
    A?: PointTarget;
    B?: PointTarget;
    C?: PointTarget;
    D?: PointTarget;
    bottom?: EdgeTarget;
    right?: EdgeTarget;
    top?: EdgeTarget;
    left?: EdgeTarget;
  };
  names?: { s?: string; d?: string };
}

// =============================================================================
// STRUCTURAL CONSTANTS
// =============================================================================

export const SQUARE_EDGE_NAMES: readonly string[] = ['bottom', 'right', 'top', 'left'] as const;
export const SQUARE_PROPERTY_FOR_EDGE: Record<string, 's'> = { bottom: 's', right: 's', top: 's', left: 's' };

// =============================================================================
// DISPLAY DEFAULTS
// =============================================================================

/**
 * Default display theme for squares.
 *
 * Same edge color scheme as rectangle: bottom=sky, right=pink, top=purple, left=teal
 * Angle colors: alpha=sky, beta=pink, gamma=purple, delta=teal
 */
export const SQUARE_DEFAULTS: GeometryElementDisplayConfig = {
  polygon: { fillColor: 'sky', fillOpacity: 0.1 },
  line: { strokeWidth: 2, color: 'neutral' },
  point: { visible: false, size: 3 },
  angle: { fillOpacity: 0.2, radius: 0.4, visible: false },
  subparts: {
    bottom: { line: { color: 'sky' } },
    right: { line: { color: 'pink' } },
    top: { line: { color: 'purple' } },
    left: { line: { color: 'teal' } },
    // Angles (90 degree markers, hidden by default)
    alpha: { angle: { fillColor: 'sky', strokeColor: 'sky', visible: false } },
    beta: { angle: { fillColor: 'pink', strokeColor: 'pink', visible: false } },
    gamma: { angle: { fillColor: 'purple', strokeColor: 'purple', visible: false } },
    delta: { angle: { fillColor: 'teal', strokeColor: 'teal', visible: false } },
    // Points
    A: { point: { color: 'sky' } },
    B: { point: { color: 'pink' } },
    C: { point: { color: 'purple' } },
    D: { point: { color: 'teal' } },
  },
};
